<template>
  <div class="apartments">
    <div class="categoryTitleWrapper">
      <div class="gardeshgariTitle">{{ categoryName }}</div>
    </div>
    <div class="amlakFilterWrapper" :class="{ showShadow: showShadow }">
      <div class="wrapperContainer">
        <div class="searchBarWrapper">
          <div class="apartmentClassSearchBar">
            <div class="topNav__searchbar_wrapper">
              <div class="filterbutton_wrapper">
                <button ref="filterButton" class="filterbutton">
                  <VsxIcon
                    iconName="SearchNormal1"
                    :size="23"
                    color="#000"
                    type="linear"
                    @click="_search"
                  />
                </button>
              </div>
              <input
                type="text"
                v-model="fillter.nickname"
                class="searchbar_input"
                placeholder="دنبال کی میگردی..."
                @keyup.enter="_search"
              />
            </div>
          </div>
          <div class="resBackBtn" @click="historyBackHandler">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
              <path
                d="M73.4 297.4C60.9 309.9 60.9 330.2 73.4 342.7L233.4 502.7C245.9 515.2 266.2 515.2 278.7 502.7C291.2 490.2 291.2 469.9 278.7 457.4L173.3 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L173.3 288L278.7 182.6C291.2 170.1 291.2 149.8 278.7 137.3C266.2 124.8 245.9 124.8 233.4 137.3L73.4 297.3z"
              />
            </svg>
          </div>
        </div>
        <div v-if="$route.path == '/top-users'" class="wrapperTabs">
          <div class="tabsContainer">
            <div
              class="containerThumb"
              :class="{ active: fillter.role == 'all' }"
              @click="fillterRoleHandler('all')"
            >
              همه
            </div>
            <div
              class="containerThumb"
              :class="{ active: fillter.role == 'branch_admin' }"
              @click="fillterRoleHandler('branch_admin')"
            >
              مشاور
            </div>
            <div
              class="containerThumb"
              :class="{ active: fillter.role == 'builder' }"
              @click="fillterRoleHandler('builder')"
            >
              سازنده
            </div>
            <div
              class="containerThumb"
              :class="{ active: fillter.role == 'consultant' }"
              @click="fillterRoleHandler('consultant')"
            >
              مباشر
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="builder_list.length == 0 && isLoading"
      style="
        display: grid;
        grid-template-columns: repeat(5, 19%);
        margin-top: 48px;
      "
      class="apartmentsListContainer"
    >
      <Skeletor
        v-for="(v, i) in 12"
        :key="i"
        class="ChildShowTabToUserCustomer sliderBottm buildingSk"
        height="200"
        style="
          background: rgb(163, 219, 213);
          margin-bottom: 2rem;
          border-radius: 10px;
        "
      />
    </div>

    <div v-show="builder_list.length > 0 && !isLoading">
      <div
        style="
          display: grid;
          grid-template-columns: repeat(5, 19%);
          margin-top: 48px;
        "
        class="apartmentsListContainer1"
      >
        <div
          style="margin-top: 5px"
          v-for="(user, i) in builder_list"
          :key="i"
          class="UserVForSlider1"
          @click="user_profile(user.role, user.uid)"
        >
          <div class="userPrize">
            <span v-if="i == 0">
              <svg
                viewBox="-3.5 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M9.73795 18.8436L12.9511 20.6987L6.42625 32L4.55349 27.8233L9.73795 18.8436Z"
                    fill="#CE4444"
                  ></path>
                  <path
                    d="M9.73795 18.8436L6.52483 16.9885L0 28.2898L4.55349 27.8233L9.73795 18.8436Z"
                    fill="#983535"
                  ></path>
                  <path
                    d="M14.322 18.8436L11.1088 20.6987L17.6337 32L19.5064 27.8233L14.322 18.8436Z"
                    fill="#983535"
                  ></path>
                  <path
                    d="M14.322 18.8436L17.5351 16.9885L24.0599 28.2898L19.5064 27.8233L14.322 18.8436Z"
                    fill="#CE4444"
                  ></path>
                  <path
                    d="M22.9936 11.0622C22.9936 17.1716 18.0409 22.1243 11.9314 22.1243C5.82194 22.1243 0.869249 17.1716 0.869249 11.0622C0.869249 4.9527 5.82194 0 11.9314 0C18.0409 0 22.9936 4.9527 22.9936 11.0622Z"
                    fill="url(#paint0_linear_103_1801)"
                  ></path>
                  <path
                    d="M20.5665 11.0621C20.5665 15.8311 16.7004 19.6972 11.9315 19.6972C7.16247 19.6972 3.29645 15.8311 3.29645 11.0621C3.29645 6.29315 7.16247 2.42713 11.9315 2.42713C16.7004 2.42713 20.5665 6.29315 20.5665 11.0621Z"
                    fill="#A88300"
                  ></path>
                  <path
                    d="M21.0477 11.984C21.0477 16.7641 17.1727 20.6391 12.3926 20.6391C7.61251 20.6391 3.73748 16.7641 3.73748 11.984C3.73748 7.20389 7.61251 3.32887 12.3926 3.32887C17.1727 3.32887 21.0477 7.20389 21.0477 11.984Z"
                    fill="#C28B37"
                  ></path>
                  <path
                    d="M20.5868 11.0621C20.5868 15.8422 16.7118 19.7172 11.9317 19.7172C7.15159 19.7172 3.27656 15.8422 3.27656 11.0621C3.27656 6.28205 7.15159 2.40702 11.9317 2.40702C16.7118 2.40702 20.5868 6.28205 20.5868 11.0621Z"
                    fill="#C09525"
                  ></path>
                  <path
                    d="M11.9781 5.04096L13.8451 8.77502L17.5792 9.24178L15.0151 12.117L15.7122 16.2431L11.9781 14.3761L8.24404 16.2431L8.94729 12.117L6.37701 9.24178L10.1111 8.77502L11.9781 5.04096Z"
                    fill="url(#paint1_linear_103_1801)"
                  ></path>
                  <defs>
                    <linearGradient
                      id="paint0_linear_103_1801"
                      x1="11.1804"
                      y1="4.03192"
                      x2="12.6813"
                      y2="31.965"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFC600"></stop>
                      <stop offset="1" stop-color="#FFDE69"></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_103_1801"
                      x1="11.9783"
                      y1="5.04096"
                      x2="11.9783"
                      y2="16.2431"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFFCDD"></stop>
                      <stop offset="1" stop-color="#FFE896"></stop>
                    </linearGradient>
                  </defs>
                </g>
              </svg>
            </span>
            <span v-if="i == 1">
              <svg
                viewBox="-3.5 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M9.73779 18.8436L12.9509 20.6987L6.42609 32.0001L4.55333 27.8234L9.73779 18.8436Z"
                    fill="#418ED6"
                  ></path>
                  <path
                    d="M9.73779 18.8436L6.52467 16.9885L-0.000155079 28.2899L4.55333 27.8234L9.73779 18.8436Z"
                    fill="#2B63A6"
                  ></path>
                  <path
                    d="M14.3218 18.8436L11.1087 20.6987L17.6335 32.0001L19.5062 27.8234L14.3218 18.8436Z"
                    fill="#2B63A6"
                  ></path>
                  <path
                    d="M14.3218 18.8436L17.5349 16.9885L24.0597 28.2899L19.5062 27.8234L14.3218 18.8436Z"
                    fill="#418ED6"
                  ></path>
                  <circle
                    cx="12.0246"
                    cy="11.0622"
                    r="11.0622"
                    fill="#E3E3E3"
                  ></circle>
                  <circle
                    cx="12.0247"
                    cy="11.0621"
                    r="8.63501"
                    fill="#595959"
                  ></circle>
                  <mask
                    id="mask0_103_1231"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="3"
                    y="3"
                    width="19"
                    height="18"
                  >
                    <circle
                      cx="12.4857"
                      cy="11.984"
                      r="8.65511"
                      fill="#C28B37"
                    ></circle>
                  </mask>
                  <g mask="url(#mask0_103_1231)">
                    <circle
                      cx="12.0247"
                      cy="11.0622"
                      r="8.65511"
                      fill="url(#paint0_linear_103_1231)"
                    ></circle>
                  </g>
                  <path
                    d="M12.0713 5.04102L13.9383 8.77508L17.6724 9.24183L15.1083 12.1171L15.8054 16.2432L12.0713 14.3762L8.33724 16.2432L9.04049 12.1171L6.47021 9.24183L10.2043 8.77508L12.0713 5.04102Z"
                    fill="url(#paint1_linear_103_1231)"
                  ></path>
                  <defs>
                    <linearGradient
                      id="paint0_linear_103_1231"
                      x1="12.0247"
                      y1="2.4071"
                      x2="12.0247"
                      y2="19.7173"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#9CA1A3"></stop>
                      <stop
                        offset="1"
                        stop-color="#9CA1A3"
                        stop-opacity="0"
                      ></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_103_1231"
                      x1="12.0713"
                      y1="5.04102"
                      x2="12.0713"
                      y2="16.2432"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#F1F5F5"></stop>
                      <stop offset="0.0001" stop-color="white"></stop>
                      <stop offset="1" stop-color="#F1F5F5"></stop>
                    </linearGradient>
                  </defs>
                </g>
              </svg>
            </span>
            <span v-if="i == 2">
              <svg
                viewBox="-3.5 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M9.73779 18.8436L12.9509 20.6987L6.42609 32.0001L4.55333 27.8234L9.73779 18.8436Z"
                    fill="#AA75CB"
                  ></path>
                  <path
                    d="M9.73779 18.8436L6.52467 16.9885L-0.000155079 28.2899L4.55333 27.8234L9.73779 18.8436Z"
                    fill="#73488D"
                  ></path>
                  <path
                    d="M14.3218 18.8436L11.1087 20.6987L17.6335 32.0001L19.5062 27.8234L14.3218 18.8436Z"
                    fill="#73488D"
                  ></path>
                  <path
                    d="M14.3218 18.8436L17.5349 16.9885L24.0597 28.2899L19.5062 27.8234L14.3218 18.8436Z"
                    fill="#AA75CB"
                  ></path>
                  <circle
                    cx="12.0246"
                    cy="11.0622"
                    r="11.0622"
                    fill="#DC9E42"
                  ></circle>
                  <circle
                    cx="12.0247"
                    cy="11.0621"
                    r="8.63501"
                    fill="#734C12"
                  ></circle>
                  <mask
                    id="mask0_103_1242"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="3"
                    y="3"
                    width="19"
                    height="18"
                  >
                    <circle
                      cx="12.4857"
                      cy="11.984"
                      r="8.65511"
                      fill="#C28B37"
                    ></circle>
                  </mask>
                  <g mask="url(#mask0_103_1242)">
                    <circle
                      cx="12.0247"
                      cy="11.0622"
                      r="8.65511"
                      fill="#A36D1D"
                    ></circle>
                  </g>
                  <path
                    d="M12.0713 5.04102L13.9383 8.77508L17.6724 9.24183L15.1083 12.1171L15.8054 16.2432L12.0713 14.3762L8.33724 16.2432L9.04049 12.1171L6.47021 9.24183L10.2043 8.77508L12.0713 5.04102Z"
                    fill="url(#paint0_linear_103_1242)"
                  ></path>
                  <defs>
                    <linearGradient
                      id="paint0_linear_103_1242"
                      x1="12.0713"
                      y1="5.04102"
                      x2="12.0713"
                      y2="16.2432"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FCFF80"></stop>
                      <stop offset="0.401042" stop-color="#FDE870"></stop>
                      <stop offset="1" stop-color="#FFC759"></stop>
                    </linearGradient>
                  </defs>
                </g>
              </svg>
            </span>
          </div>
          <div class="destopRate">
            <div class="rateThumb rate">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
                />
              </svg>

              <div class="rateTitle" v-if="user.user_rate">
                {{ parseFloat(user.user_rate) }}
              </div>
              <div class="rateTitle" v-else>0</div>
            </div>
            <div class="rateThumb comment">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                />
              </svg>

              <div class="rateTitle" v-if="fillter.role == 'consultant'">
                {{ user.consultant_comments }}
              </div>
              <div class="rateTitle" v-else>{{ user.builder_comments }}</div>
            </div>
          </div>
          <div class="mobileRate">
            <div v-if="user.user_rate" class="rateThumb rate">
              <!-- <el-rate v-model="user.user_rate" disabled /> -->
              <span>{{ parseFloat(user.user_rate).toFixed(0) }}</span>
              <i class="fa-solid fa-star"></i>
            </div>
            <div class="rateThumb comment">
              <div class="rateTitle" v-if="fillter.role == 'consultant'">
                {{ user.consultant_comments }}
              </div>
              <div class="rateTitle" v-else>
                {{ user.builder_comments }}
              </div>
              <i class="fas fa-comment-dots"></i>
            </div>
          </div>
          <img v-lazy :data-src="user.avatar" :alt="user.nickname" />
          <div class="userInfo">
            <p class="userTitle">
              {{ user.nickname }}
            </p>

            <div class="showNumberLoadButtonVisibleCount">
              <div class="ChildShowPTag">
                <span> شماره تماس: </span>
                <p>{{ user.mobile }}</p>
              </div>

              <div v-if="showTop" class="ChildShowPTag">
                <p>{{ user.role_fa }}</p>
                <!--            <p> {{ user.all.madrak }}</p>-->
              </div>
              <div
                class="ChildShowPTag activityThumbWrapper"
                v-if="
                  !showTop &&
                  user &&
                  user.b_activity_type &&
                  user.b_activity_type.length > 0
                "
              >
                <span> نوع فعالیت : </span>
                <p
                  v-for="(v, i) in user.b_activity_type"
                  :key="i"
                  class="activityThumb"
                >
                  {{ v }}
                </p>
                <!--            <p> {{ user.all.madrak }}</p>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loadeMoreLoader" v-if="loadmore_loading">
        <span class="custom-loader"></span>
      </div>
      <div ref="loadMoreTrigger" class="trigger"></div>
    </div>

    <!-- <div
      v-if="builder_list.length > 0 && loadmore && !isLoading"
      class="apartmentsLoadMoreDataButton"
    >
      <button
        class="loadButton"
        @click="load_builder()"
        :disabled="loadmore_loading"
      >
        <span v-if="!loadmore_loading">نمایش بیشتر</span>
        <span v-else class="loader"></span>
      </button>
    </div> -->

    <div
      v-if="builder_list.length == 0 && !isLoading"
      class="justify-center align-center mt-4"
      style="text-align: center; height: 90%"
    >
      <img
        :src="publicPath + 'img/notfound.png'"
        alt="Alt text"
        width="320"
        height="280"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store";
import { Skeletor } from "vue-skeletor";

export default {
  name: "buildersList",
  components: { Skeletor },
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      isLoading: true,
      loadmore: false,
      loadmore_loading: false,
      isFilterOpen: false,
      dynamicStyles:
        "height: 0; overflow: hidden; transition: height 0.3s ease;",
      showTop: false,
      showShadow: false,
      fillter: {
        nickname: "",
        role: "all",
        status: "all",
        page: 1,
        per_page: 12,
      },
      categoryName: "",
      builder_list: [],
    };
  },
  watch: {
    "fillter.role"() {
      this.categoryNameHandler();
    },
    "$route.path": {
      immediate: true,
      handler(newPath) {
        this.showTop = newPath === "/top-users";
      },
    },
    "$route.query.role": {
      handler(newVal) {
        if (newVal) {
          this.fillter.role = newVal;
          this.load_builder("first");
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    document.addEventListener("scroll", this.handleWindowScroll);
    this.categoryNameHandler();
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("scroll", this.handleWindowScroll);
  },
  methods: {
    categoryNameHandler() {
      if (this.$route.path == "/top-users") {
        this.categoryName = "برترین از نگاه شما";
      } else {
        switch (this.fillter.role) {
          case "builder":
            this.categoryName = "سازندگان معتبر";
            break;
          case "consultant":
            this.categoryName = "برترین مباشران";
            break;
        }
      }
    },
    historyBackHandler() {
      history.back();
    },
    handleWindowScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight + 100 >= fullHeight) {
        if (this.loadmore && !this.loadmore_loading) {
          this.load_builder();
        }
      }

      if (window.innerWidth < 700 && window.scrollY > 86) {
        this.showShadow = true;
      } else {
        this.showShadow = false;
      }
    },
    load_builder(param) {
      this.loadmore = true;
      this.loadmore_loading = true;
      this.fillter.page += 1;
      if (param == "first") {
        this.isLoading = true;
        this.builder_list = [];
        this.fillter.page = 1;
      }
      const routePath = this.$route.path;
      console.log("route", routePath);

      if (routePath == "/top-users") {
        axios
          .post(store.getters.baseUrl + "/user-top", this.fillter)
          .then((r) => {
            if (r.data.result == 0) {
              this.builder_list = [];
              if (param != "first") {
                this.fillter.page -= 1;
              }
            } else {
              this.builder_list = this.builder_list.concat(r.data.list.list);
              if (r.data.list.total_page == this.fillter.page) {
                this.loadmore = false;
              }
            }
            this.isLoading = false;
            this.loadmore_loading = false;

            console.log(" builder_list.value", this.builder_list);
          });
      } else {
        axios
          .post(store.getters.baseUrl + "/user-list", this.fillter)
          .then((r) => {
            if (r.data.result == 0) {
              this.builder_list = [];
              if (param != "first") {
                this.fillter.page -= 1;
              }
            } else {
              this.builder_list = this.builder_list.concat(r.data.list.list);
              if (r.data.list.total_page == this.fillter.page) {
                this.loadmore = false;
              }
            }
            this.isLoading = false;
            this.loadmore_loading = false;

            console.log(" builder_list.value", this.builder_list);
          });
      }
    },
    _search() {
      if (
        this.fillter.nickname.trim().length >= 3 ||
        this.fillter.nickname.trim().length == 0
      ) {
        setTimeout(() => {
          this.load_builder("first");
        }, 2000);
      }
    },
    user_profile(role, uid) {
      if (role == "consultant") {
        this.$router.push(`/profile-superior?uid=${uid}`);
      } else {
        this.$router.push({ path: "/profile-amlak", query: { uid } });
      }
    },
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;
      this.dynamicStyles = this.isFilterOpen
        ? "height: 436px; overflow: hidden; transition: height 0.3s ease;"
        : "height: 0; overflow: hidden; transition: height 0.3s ease;";
    },
    handleClickOutside(event) {
      const filterButtonEl = this.$refs.filterButton;
      const filterBoxEl = this.$refs.filterBox;
      if (
        filterButtonEl &&
        this.isFilterOpen &&
        !filterButtonEl.contains(event.target) &&
        (!filterBoxEl || !filterBoxEl.contains(event.target))
      ) {
        this.toggleFilter();
      }
    },
    fillterRoleHandler(role) {
      if (role) {
        this.$router.push(`/top-users?role=${role}`);
        // this.load_builder("first");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ShowTabToUserCustomer {
  width: 100% !important;
}

.topNav__searchbar_wrapper {
  width: 100% !important;
}

.loader {
  height: 40px;
  width: 40px;
  margin-top: 0 !important;
}

.classShowApartmentSow {
  position: relative;
}

.deleteIcon {
  position: absolute;
  top: 4%;
  left: 4%;
  width: 32px;
  aspect-ratio: 1;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  span {
    font-size: 1.25rem;
    color: #2dc635;
  }
}

.loader {
  height: 40px;
  width: 40px;
  margin-top: 0 !important;
}

.dark {
  .categoryTitleWrapper {
    .gardeshgariTitle {
      color: #fff !important;
    }
  }
}

.categoryTitleWrapper {
  width: 100%;
  text-align: center;
  margin-top: -16px;
  margin-bottom: 24px;

  .gardeshgariTitle {
    width: 100% !important;

    &::after,
    &::before {
      width: 90px !important;
    }
  }
}

@media (min-width: 700px) {
  .categoryTitleWrapper {
    display: none;
  }
}

.dark {
  .UserVForSlider1 {
    &:first-child {
      background: linear-gradient(135deg, #d4af37, #b8860b);
    }

    &:nth-child(2) {
      background: linear-gradient(135deg, #dcdcdc, #a9a9a9);
    }

    &:nth-child(3) {
      background: linear-gradient(135deg, #cd7f32, #8b4513);
    }

    .destopRate {
      .rateThumb {
        color: #fff;
      }
    }
  }
}

.UserVForSlider1 {
  position: relative;

  &:first-child {
    background: linear-gradient(135deg, #d4af37, #f9e79f);
  }

  &:nth-child(2) {
    background: linear-gradient(135deg, #bdc3c7, #ecf0f1);
  }

  &:nth-child(3) {
    background: linear-gradient(135deg, #c9894b, #edc796);
  }

  .userPrize {
    position: absolute;
    top: 8px;
    right: 8px;

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .destopRate {
    position: absolute;
    top: 12px;
    left: 12px;

    .rateThumb {
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      gap: 4px;
      font-size: 1rem;

      &:first-of-type {
        margin-bottom: 2px;
      }

      svg {
        width: 18px;
        height: 18px;
      }

      &.rate svg {
        stroke: #ffb703;
        fill: #ffb703;
      }
      &.comment svg {
        stroke: #fff;
        fill: #0096c7;
      }
    }
  }

  .mobileRate {
    display: none;
  }
}

.activityThumb {
  &:not(:last-child) {
    display: inline-flex;

    &::after {
      content: "-";
      margin: 0 6px;
    }
  }
}

.activityThumbWrapper {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;

  span {
    white-space: nowrap;
  }

  p,
  span {
    color: #333 !important;
  }
}

.wrapperTabs {
  display: block;
  width: 100%;
  margin-top: 20px;
  max-width: 482px;
  margin-left: auto;
  margin-right: auto;

  .tabsContainer {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;

    .containerThumb {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 12px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
      font-size: 14px;
      cursor: pointer;
      transition: all 0.1s;
      background: #faf9fb;
      color: #000;
      border: 1px solid rgb(209, 213, 219);

      &:active {
        transform: scale(0.95);
      }

      &.active {
        color: #fff;
        background: #0096c7;
        border-color: #0096c7;
      }
    }
  }
}
@media (max-width: 700px) {
  .UserVForSlider1 {
    &:first-child,
    &:nth-child(2),
    &:nth-child(3) {
      .mobileRate {
        .rateThumb {
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
        }
      }
    }
    .destopRate {
      display: none;
    }

    .mobileRate {
      display: block;
      position: absolute;
      left: 16px;
      top: 16px;
      text-align: left;

      .rateThumb {
        padding: 4px 10px;
        background: rgb(248 249 250);
        border-radius: 9999px;

        i {
          font-size: 0.85rem;
          color: #ffd700;
        }

        &.rate {
          width: fit-content;
          display: flex;
          align-items: center;
          justify-content: left;
          gap: 4px;
          margin-bottom: 8px;

          i {
            display: block;
            margin-top: -4px;
          }

          :deep(.el-rate) {
            height: auto !important;
            .el-rate__item {
              .el-icon {
                margin: 0;
                width: 16px;
                height: 16px;

                svg {
                  width: 16px;
                  height: 16px;
                }
              }
            }
          }

          span {
            font-size: 0.925rem;
          }
        }

        &.comment {
          width: fit-content;
          display: flex;
          align-items: center;
          justify-content: left;
          gap: 4px;
          margin-right: auto;

          i {
            font-size: 0.85rem;
            color: #0096c7;
          }

          .rateTitle {
            font-size: 0.85rem;
          }
        }
      }
    }

    img {
      width: 49px;
      height: 49px;
    }

    .userInfo {
      & > p {
        margin-top: 0;
        font-size: 1rem;
        line-height: 1.5rem;
      }

      .showNumberLoadButtonVisibleCount {
        .ChildShowPTag {
          &:first-child {
            margin-top: 0.125rem;
            p,
            span {
              font-size: 0.875rem;
              line-height: 1.25rem;
              color: rgb(75 85 99);
              margin-bottom: 0;
            }
          }

          &:not(:first-child) {
            margin-top: 4px;
            p,
            span {
              font-size: 0.75rem;
              line-height: 1rem;
              color: #333;
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}
</style>
